// extracted by mini-css-extract-plugin
export default {"infoCell":"cazUc784PITx5VItFzjw","title":"Mgkimrn8gHog_nOhTy6P","info":"wvASrvhiQQ3CZqUnKOHC"};